/* *
 * cache-burst-poll.js
 *
 * Polls the API every 5 minutes for the last admin-triggered cache burst timestamp.
 * When the timestamp changes, clears the service worker cache and reloads.
 *
 * This covers the static site (ascenddraft.com) which has no Socket.IO connection.
 * The static site (ascenddraft.com) handles updates via polling instead of sockets. */

const API_CACHE_VERSION_URL = 'https://api.ascenddraft.com/api/admin/cache-version';
const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const STORAGE_KEY = 'ascend:cache-bust-at';

async function checkCacheVersion() {
  try {
    const res = await fetch(API_CACHE_VERSION_URL, { cache: 'no-store' });
    if (!res.ok) return;
    const { bustedAt } = await res.json();
    if (!bustedAt) return; // no bust has ever been triggered

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === String(bustedAt)) return; // no change

    // New bust detected — clear SW caches and reload
    localStorage.setItem(STORAGE_KEY, String(bustedAt));

    if ('serviceWorker' in navigator) {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg?.active) {
        reg.active.postMessage({ type: 'CLEAR_CACHE' });
        // Give the SW ~500ms to clear before reloading
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    window.location.reload(true);
  } catch (_) {
    // Silent — polling failure is non-fatal
  }
}

// Run once on page load (catches a bust that happened while the tab was closed)
checkCacheVersion();

// Then poll on interval
setInterval(checkCacheVersion, POLL_INTERVAL_MS);
